import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const CircleChevronDownIcon: React.FC<OneColorIconProps> = ({ size = 32, color = 'white', className }) => {
  const stroke = getHexColor(color)

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.5 28C23.1274 28 28.5 22.6274 28.5 16C28.5 9.37258 23.1274 4 16.5 4C9.87258 4 4.5 9.37258 4.5 16C4.5 22.6274 9.87258 28 16.5 28Z"
        stroke={stroke}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M21 14.5L16.5 19.5L12 14.5"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
